import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Star } from "lucide-react";
import FormItem from "components/fields/FormItem";
import { Form, Input } from "antd";
import Button from "components/button";
import { requiredField } from "utils/crudSagaHelper";
import {
  getMonthlyPerfReviewItems
} from "../../../../../redux/performancereviewitem/performanceReviewItemState";
import {
  doPerfReviewUpdate
} from "../../../../../redux/performancereview/performanceReviewState";
import { removeActiveModal } from '../../../../../redux/layout/layoutState';

const starStyleClass = [
  "border-red-100 bg-red-50 dark:border-red-800 dark:bg-red-900/20",
  "border-orange-100 bg-orange-50/40 dark:border-orange-800 dark:bg-orange-900/20",
  "border-blue-100 bg-blue-50/40 dark:border-blue-800 dark:bg-blue-900/20",
  "border-yellow-100 bg-yellow-50/60 dark:border-yellow-800 dark:bg-yellow-900/20",
  "border-yellow-200 bg-yellow-50 dark:border-yellow-700 dark:bg-yellow-900/30",
];

const StartMonthlyReviewForm = ({recordData}) => {
  const [form] = Form.useForm();
  const [selectedRating, setSelectedRating] = useState(null);
  const dispatch = useDispatch();
  const monthlyPerformanceItems = useSelector((state) => state.performanceReviewItem.monthlyPerfReviewItems.items);
    
  useEffect(() => {
      dispatch(getMonthlyPerfReviewItems({for_monthly: 1}));
  },[dispatch]);

  const onSubmit = (formData) => { 
      try {
        if(selectedRating){
          const { pfr_id } = recordData;
          const pfr_result = {
            rating: selectedRating,
            reason: formData.reason_2 ?? formData.reason_1,
          };

          dispatch(doPerfReviewUpdate({pfr_id, pfr_result}))
        }
      } catch (error) {
        console.error("Save failed:", error);
      }
    };

  return (
    <Form form={form} 
      onFinish={onSubmit}
    >
      <div className="space-y-2">
        {monthlyPerformanceItems.map((item) => (
            <div>
              <div
                key={item.stars}
                onClick={() => setSelectedRating(item.stars)}
                className={`flex cursor-pointer items-start rounded-lg border-2 p-3 transition-all duration-200
                ${starStyleClass[item.stars-1]}
                ${
                  selectedRating === item.stars
                    ? "ring-2 ring-green-500"
                    : "hover:border-green-300"
                }`}
                
              >
                <div className="flex shrink-0">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      className={`w-4 h-4 ${
                        i < item.stars
                          ? "text-yellow-400 fill-yellow-400"
                          : "text-gray-300 fill-gray-400"
                      }`}
                    />
                  ))}
                </div>

                <div className="px-2">
                  <div className="text-sm font-semibold title-text">
                    {item.pri_title}
                  </div>

                  <div className="mt-0.5 text-xs muted-text">
                    {item.pri_description}
                  </div>
                </div>
              </div>
                {(item.stars <= 2 && selectedRating === item.stars) && (
                  <div
                    className="mt-2"
                    onClick={(e) => e.stopPropagation()} 
                  >
                    
                        <FormItem 
                          name={`reason_${item.stars}`}
                          label="Reason"
                          rules={[requiredField]}
                        >
                          <Input.TextArea
                            rows={2}
                            placeholder="Describe the performance concerns and improvement areas..."
                          />
                        </FormItem>
                  </div>
                )}
            </div>
          )
        )}
        <div className="p-4 flex justify-end gap-2">
            <Button
              className="btn-base h-9 title-text"
              onClick={()=>dispatch(removeActiveModal('monthly_perf_review'))}
            >
              Close
            </Button>
            <Button
              type="submit" 
              className="btn-approve h-9"
            >
              Submit Review
            </Button>
          </div>
      </div>
    </Form>
  );
};

export default StartMonthlyReviewForm;